import { FC, useMemo, useState, useEffect, useRef, } from "react";
// 组件
import SuperSelect from '../SuperSelect';
import TextAreaRow from '../TextAreaRow';
import RadioGroup from "../RadioGroup";
// 方法
import classNames from "classnames";
import { filterEmptyGroupSearchValue } from "./util";
// 常量
import { DEFAULT_FIELD_NAMES, GroupSearchProps, GroupSearchValue, } from "./interface";
import { SelectOption, SelectValue, } from "../SuperSelect/interface";
import { RadioChangeEvent } from "antd/lib/radio";
import './style.less';

/** 下拉+(多行输入框+匹配类型) 组合搜索 */
const GroupSearch: FC<GroupSearchProps> = props => {
  const {
    value: outValue, className, style, defaultValue, disabled, beforeSuperSelectProps,
    upperCaseSearchType, matchRuleRadioGroupProps, textAreaRowProps, fieldNames, onChange,
  } = props;
  const [value, setValue] = useState<GroupSearchValue | undefined>(filterEmptyGroupSearchValue(defaultValue, fieldNames));
  const [placeholder, setPlaceholder] = useState<string>(); // 多行文本框提示文字
  const isFirst = useRef<boolean>(true); // 是否需要根据外部传入value设置值
  /** 根据外部传入value设置值 */
  useEffect(() => {
    if (isFirst.current && !outValue) {
      isFirst.current = false;
      return;
    }
    const newValue = filterEmptyGroupSearchValue(outValue, fieldNames);
    setValue(newValue);
    isFirst.current = false;
  }, [outValue, fieldNames]);
  /** 前置类型下拉改变 */
  const handleAfterChange = (beforeValue?: SelectValue, options?: SelectOption) => {
    const newValue: GroupSearchValue = {
      [fieldNames?.searchType || DEFAULT_FIELD_NAMES.searchType]: beforeValue,
      // [fieldNames?.matchValue || DEFAULT_FIELD_NAMES.matchValue]: undefined,
    }
    setPlaceholder(options?.label as string);
    handleChange(newValue);
  };
  /** 中间匹配规则下拉改变 */
  const handleMatchRuleChange = (event: RadioChangeEvent) => {
    handleChange({ [fieldNames?.matchCondition || DEFAULT_FIELD_NAMES.matchCondition]: event.target.value, });
  };
  /** 末尾值改变 */
  const handleValueChange = (afterValue: any) => {
    handleChange({ [fieldNames?.matchValue || DEFAULT_FIELD_NAMES.matchValue]: afterValue, });
  };
  /** value值改变 */
  const handleChange = (otherValue: GroupSearchValue) => {
    setValue(prev => {
      const newValue = filterEmptyGroupSearchValue({ ...prev, ...otherValue, }, fieldNames);
      onChange?.(newValue);
      return newValue;
    });
  };
  /** 组件类名 */
  const classes = useMemo(() => {
    return classNames('yb-group-search', className, {
      'yb-group-search-disabled': disabled,
    });
  }, [className]);
  /** 前置下拉类名 */
  const beforeClasses = useMemo(() => {
    return classNames('yb-group-search-before', beforeSuperSelectProps?.className);
  }, [beforeSuperSelectProps?.className]);
  /** 后置多行文本输入框类名 */
  const afterClasses = useMemo(() => {
    return classNames('yb-group-search-after', textAreaRowProps?.className);
  }, [textAreaRowProps?.className]);

  return (
    <div className={classes} style={style}>
      <SuperSelect
        showSearch={false}
        allowClear
        {...beforeSuperSelectProps}
        className={beforeClasses}
        value={value?.[fieldNames?.searchType || DEFAULT_FIELD_NAMES.searchType]}
        onChange={handleAfterChange}
      />
      <TextAreaRow
        placeholder={placeholder}
        allowClear
        {...textAreaRowProps}
        className={afterClasses}
        value={value?.[fieldNames?.matchValue || DEFAULT_FIELD_NAMES.matchValue]}
        isUpperCase={upperCaseSearchType?.includes(value?.[fieldNames?.searchType || DEFAULT_FIELD_NAMES.searchType])}
        onChange={handleValueChange}
        dropdownHeader={
          <div className='flex-center-start' style={{ marginBottom: 4, }}>
            {
              !!matchRuleRadioGroupProps?.title && (
                <div className='p-r-s'>{matchRuleRadioGroupProps.title}:</div>
              )
            }
            <RadioGroup
              size="small"
              {...matchRuleRadioGroupProps}
              value={value?.[fieldNames?.matchCondition || DEFAULT_FIELD_NAMES.matchCondition]}
              onChange={handleMatchRuleChange}
            />
          </div>
        }
      />
    </div>
  );
};

GroupSearch.defaultProps = {
  fieldNames: DEFAULT_FIELD_NAMES,
};

export default GroupSearch;
